<span id="latex-rendering-{{uuid}}" class="latex"
      [ngClass]="{'disabled': disable}"></span>
<div *ngIf="!displayForSummary || !displaySolution" id="latex-keyboard-{{uuid}}"></div>
